import { useMutation } from '@tanstack/react-query'

import { httpService } from '@/api/v1/http.service'

const useRemoveCourses = ({
  onSuccess,
  onError
}: {
  onSuccess: (data: {
    successfully_deleted: number
    unsuccessfully_deleted: number
  }) => void
  onError: () => void
}) =>
  useMutation({
    mutationFn: (courseIds: string[]) =>
      httpService.panel.panelCoursesBulkDeleteCreate({
        courses_ids: courseIds
      }),
    onSuccess,
    onError
  })

export default useRemoveCourses
